import { LoggerService } from './Services/Logging/LoggerService';
import { TypedEvent } from './TypedEvent';
export class DependencyContainer {
    constructor() {
        this._services = new Map();
        this._serviceRegistrationEvent = new TypedEvent();
    }
    static get Instance() {
        const g = globalThis;
        if (g.__dc_instance)
            return g.__dc_instance;
        const inst = new DependencyContainer();
        g.__dc_instance = inst;
        if (typeof window !== 'undefined' && !window.LavvaDI)
            window.appservices = inst;
        this.Log = new LoggerService();
        this.Log.Warning('Initializing DependencyContainer');
        inst.RegisterService(this.Log);
        this.IsInitialized = true;
        return inst;
    }
    RegisterService(srv) {
        this._services.set(srv.GetServiceName(), srv);
        this._serviceRegistrationEvent.Invoke(srv);
    }
    GetService(name) {
        return this._services.get(name);
    }
    GetServiceAsync(name, token) {
        if (this._services.has(name)) {
            return Promise.resolve(this._services.get(name));
        }
        return new Promise((resolve, reject) => {
            const h = (s) => {
                if (s.GetServiceName() === name) {
                    this._serviceRegistrationEvent.Unsubscribe(h);
                    token === null || token === void 0 ? void 0 : token.CancellationEvent.Unsubscribe(onCancel);
                    resolve(s);
                }
            };
            const onCancel = () => {
                this._serviceRegistrationEvent.Unsubscribe(h);
                reject(new Error('cancelled'));
            };
            token === null || token === void 0 ? void 0 : token.CancellationEvent.Subscribe(onCancel);
            this._serviceRegistrationEvent.Subscribe(h);
        });
    }
    GetServiceWithTimeoutAsync(name, timeout) {
        if (this._services.has(name)) {
            return Promise.resolve(this._services.get(name));
        }
        return new Promise((resolve, reject) => {
            const h = (s) => {
                if (s.GetServiceName() === name) {
                    window.clearTimeout(tid);
                    this._serviceRegistrationEvent.Unsubscribe(h);
                    resolve(s);
                }
            };
            const tid = window.setTimeout(() => {
                this._serviceRegistrationEvent.Unsubscribe(h);
                reject(new Error(`timeout waiting for "${name}"`));
            }, timeout);
            this._serviceRegistrationEvent.Subscribe(h);
        });
    }
}
DependencyContainer.IsInitialized = false;
//# sourceMappingURL=DependencyContainer.js.map